import { ProfileView } from "@authory-packages/core";
import {
    V3IconProfileMasonry,
    V3IconProfileViewList,
    V3IconProfileViewOneColumn,
    V3IconProfileViewText,
    V3IconProfileViewTwoColumn
} from "../components/Icons";

export const getViewIcon = (profileView: ProfileView) => {
    switch (profileView) {
        case ProfileView.TwoColumnThumbnail:
            return <V3IconProfileViewTwoColumn />;
        case ProfileView.Masonry:
            return <V3IconProfileMasonry />;
        case ProfileView.OneColumnThumbnail:
            return <V3IconProfileViewOneColumn />;
        case ProfileView.List:
            return <V3IconProfileViewList />;
        case ProfileView.Text:
            return <V3IconProfileViewText />;
        default:
            return <></>;
    }
};
